import { requests } from "../../helpers/api.services";
import { DASHBOARD_URL, JOBS_URL } from "../../helpers/api.routes";
export const DashboardService = {
  getStatistics: () => requests.get(`${DASHBOARD_URL}`),
  getMonthlyGraphs: (months: number) =>
    requests.get(`${DASHBOARD_URL}/graphs/monthly`, { months }),
};
